import Vue from 'vue'
import Config from '../config/index.js'


export const getUsersData = (data) => { // 获取用户信息
  return Vue.http.post('/rest/ysh/wx/user/userData', data)
}

export const hasAnsweredQuestions = (data) => { //答过的题目信息
  return Vue.http.post('/rest/ysh/wx/answer/hasAnsweredQuestions', data)
}

export const randomSingleQuestion = (data) => { //随机一个题目-二期(此题目服务器缓存22H)
  return Vue.http.post('/rest/ysh/wx/answer/randomSingleQuestion', data)
}



/*
* 答题页
* */
export const answerAjax = {
  hasAnswered: (data) => { // 今日是否已经答过题
    return Vue.http.post('/rest/ysh/wx/answer/hasAnswered',data)
  },
  obtainUserRandomQuestion: (data) => { // 随机问题-获取问题(4道题)
    return Vue.http.post('/rest/ysh/wx/answer/obtainUserRandomQuestion',data)
  },
  obtainTiming: (data) => { // 获取倒计时
    return Vue.http.post('/rest/ysh/wx/answer/obtainTiming',data)
  },
  answerSingleQuestion: (data) => { // 回答问题(单条信息问题)
    return Vue.http.post('/rest/ysh/wx/answer/answerSingleQuestion',data)
  },
  endTimeSubmit: (data) => { // 读秒结束调用
    return Vue.http.post('/rest/ysh/wx/answer/endTimeSubmit',data)
  },
}

/*
* 打错页
* */
export const wrongAnswerCourse = (data) => { //答错问题关联课程
  return Vue.http.post('/rest/ysh/wx/answer/wrongAnswerCourse', data)
}
export const todayAnswerPrize = (data) => { //今日答题获得奖励
  return Vue.http.post('/rest/ysh/wx/answer/todayAnswerPrize', data)
}

/*
* 答对页
* */
export const redAnswer = {
  bestToday: (data) => { // 今日最佳
    return Vue.http.post('/rest/ysh/wx/answer/bestToday',data)
  },
}

/*
* 我的红包
* */
export const myPacket = {
  myRedRecord: (data) => { // 我的获奖记录
    return Vue.http.post('/rest/ysh/wx/answer/myRedRecord',data)
  },
  myDepositRecord: (data) => { // 我的提现记录
    return Vue.http.post('/rest/ysh/wx/answer/myDepositRecord',data)
  },
  myAnswerAmount: (data) => { // 我的红包总额
    return Vue.http.post('/rest/ysh/wx/answer/myAnswerAmount',data)
  },
  tixian: (data) => { // 提现
    return Vue.http.post('/rest/ysh/wx/answer/tixian',data)
  },
}

/*
 * 分享页
 * */
export const sharePageData = {
  sharePageData: (data) => { // 分享红包页面
    return Vue.http.post('/rest/ysh/wx/answer/sharePageData',data)
  },
  unPackRedPack: (data) => { // 拆别人红包
    return Vue.http.post('/rest/ysh/wx/answer/unPackRedPack',data)
  },
}

/*
  复活卡
*/

export const revive = {
  hasUserReviceToday: (data) => { // 是否使用过复活卡-二期
    return Vue.http.post('/rest/ysh/wx/answer/hasUserReviceToday',data)
  },
  myReviveCard: (data) => { // 复活卡信息-二期
    return Vue.http.post('/rest/ysh/wx/answer/myReviveCard',data)
  },
  useReviveCard: (data) => { // 使用复活卡复活-二期
    return Vue.http.post('/rest/ysh/wx/answer/useReviveCard',data)
  },
  useReviveIntegral: (data) => { // 使用积分复活-二期
    return Vue.http.post('/answer/useReviveIntegral',data)
  },
  returnIntegral: (data) => { // 不复活结束返积分-二期
    return Vue.http.post('/rest/ysh/wx/answer/returnIntegral',data)
  },

}



// WEBPACK FOOTER //
// ./src/api/ajax.js